module.exports = __webpack_public_path__ + "static/media/2.9fa5fb8a.jpg";